import React from "react";
import { makeStyles, Paper, Typography } from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { 
  TransferWithinAStation, 
  Close, 
  CheckCircle,
  Schedule,
  SwapHoriz 
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  historyItem: {
    display: "flex",
    justifyContent: "center",
    margin: "8px 0",
    alignItems: "center",
  },
  historyPaper: {
    backgroundColor: theme.palette.type === "dark" ? "#1e3a5f" : "#e3f2fd",
    color: theme.palette.type === "dark" ? "#90caf9" : "#0d47a1",
    padding: "8px 16px",
    borderRadius: "16px",
    maxWidth: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: theme.palette.type === "dark" 
      ? "0 2px 8px rgba(144, 202, 249, 0.2)" 
      : "0 2px 8px rgba(13, 71, 161, 0.15)",
    border: theme.palette.type === "dark" ? "1px solid #1976d2" : "1px solid #90caf9",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      boxShadow: theme.palette.type === "dark" 
        ? "0 4px 12px rgba(144, 202, 249, 0.3)" 
        : "0 4px 12px rgba(13, 71, 161, 0.2)",
      transform: "translateY(-1px)",
    },
  },
  icon: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  historyText: {
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "center",
  },
  timestamp: {
    fontSize: "10px",
    opacity: 0.8,
    marginLeft: "8px",
    fontWeight: 500,
  },
  transferDetails: {
    fontSize: "11px",
    opacity: 0.9,
    marginTop: "4px",
    textAlign: "center",
    fontStyle: "italic",
  },
}));

const TicketHistoryItem = ({ historyItem }) => {
  const classes = useStyles();

  const getIcon = () => {
    switch (historyItem.type) {
      case "transfer":
        return <SwapHoriz className={classes.icon} />;
      case "close":
        return <Close className={classes.icon} />;
      case "log":
        if (historyItem.action.includes("fechado")) {
          return <Close className={classes.icon} />;
        } else if (historyItem.action.includes("aberto") || historyItem.action.includes("Recebeu")) {
          return <CheckCircle className={classes.icon} />;
        } else if (historyItem.action.includes("fila")) {
          return <Schedule className={classes.icon} />;
        } else if (historyItem.action.includes("Transfer")) {
          return <TransferWithinAStation className={classes.icon} />;
        }
        return <CheckCircle className={classes.icon} />;
      default:
        return <CheckCircle className={classes.icon} />;
    }
  };

  const formatTimestamp = (timestamp) => {
    try {
      const date = typeof timestamp === "string" ? parseISO(timestamp) : timestamp;
      return format(date, "dd/MM/yyyy HH:mm");
    } catch (error) {
      return "";
    }
  };

  const getDetailedInfo = () => {
    if (historyItem.type === "transfer") {
      const parts = [];
      
      if (historyItem.executedByUser) {
        parts.push(`Por: ${historyItem.executedByUser.name}`);
      }
      
      if (historyItem.transferMessage) {
        parts.push(`Motivo: ${historyItem.transferMessage}`);
      }

      if (parts.length > 0) {
        return (
          <div className={classes.transferDetails}>
            {parts.join(" • ")}
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div className={classes.historyItem}>
      <Paper className={classes.historyPaper}>
        {getIcon()}
        <div>
          <Typography className={classes.historyText}>
            {historyItem.action}
            <span className={classes.timestamp}>
              {formatTimestamp(historyItem.timestamp)}
            </span>
          </Typography>
          {getDetailedInfo()}
        </div>
      </Paper>
    </div>
  );
};

export default TicketHistoryItem;
